var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0571 17.2531V20.2531C22.0582 20.5316 22.0011 20.8073 21.8896 21.0625C21.778 21.3176 21.6144 21.5467 21.4091 21.735C21.2039 21.9232 20.9616 22.0666 20.6978 22.1558C20.434 22.245 20.1544 22.2782 19.8771 22.2531C16.7999 21.9187 13.8441 20.8672 11.2471 19.1831C8.83089 17.6478 6.7824 15.5993 5.24706 13.1831C3.55704 10.5743 2.50531 7.6041 2.17706 4.5131C2.15207 4.23657 2.18494 3.95786 2.27356 3.69473C2.36219 3.43159 2.50463 3.18979 2.69183 2.98473C2.87902 2.77966 3.10687 2.61581 3.36085 2.50363C3.61484 2.39144 3.8894 2.33337 4.16706 2.3331H7.16706C7.65237 2.32833 8.12285 2.50018 8.49082 2.81664C8.85879 3.13309 9.09914 3.57255 9.16706 4.0531C9.29368 5.01317 9.52851 5.95583 9.86706 6.8631C10.0016 7.22103 10.0307 7.61002 9.95097 7.98398C9.87121 8.35795 9.68593 8.70121 9.41706 8.9731L8.14706 10.2431C9.57062 12.7466 11.6435 14.8195 14.1471 16.2431L15.4171 14.9731C15.689 14.7042 16.0322 14.519 16.4062 14.4392C16.7801 14.3594 17.1691 14.3886 17.5271 14.5231C18.4343 14.8617 19.377 15.0965 20.3371 15.2231C20.8228 15.2916 21.2665 15.5363 21.5836 15.9106C21.9007 16.2849 22.0692 16.7627 22.0571 17.2531Z",
    stroke: "#3466E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.844122c5b6314ea88461fe40cb491fcc.svg";
export { ForwardRef as ReactComponent };